const style = {
  container: {
    height: '475.34748077392578px',
    width: '174px',
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '-2px',
    position: 'relative',
    marginTop: '3rem',
  },
  innerContainer: {
    marginTop: '-133px',
    marginLeft: '85px',
  },
  innerContainerUp: {
    marginBottom: '-84px',
    marginLeft: '85px',
  },
  para: {
    fontFamily: "'Open Sans', sans-serif",
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '25px',
    textAlign: 'center',
    letterSpacing: '0.05em',
    color: '#000000',
    position: 'absolute',
    width: '250px',
    marginLeft: '-46px',
  },
};
export default function JourneyCard({ data, position, index, max }) {
  return (
    <div
      style={{
        ...style.container,
        marginBottom: position,
      }}
    >
      <div
        style={{
          ...style.innerContainerUp,
          visibility: index % 2 !== 0 ? 'visible' : 'hidden',
        }}
      >
        <svg
          width="40"
          height="166"
          viewBox="0 0 40 166"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="21.3223"
            y="165.762"
            width="4.16811"
            height="156.304"
            transform="rotate(180 21.3223 165.762)"
            fill="#BEA4C9"
          />
          <circle
            cx="19.7596"
            cy="19.3553"
            r="18.2775"
            transform="rotate(180 19.7596 19.3553)"
            stroke="#BEA4C9"
            strokeWidth="2"
          />
          <circle
            cx="19.2379"
            cy="19.8785"
            r="12.5043"
            transform="rotate(180 19.2379 19.8785)"
            fill="#BEA4C9"
          />
        </svg>
      </div>

      <svg
        width="174"
        height="111"
        viewBox="0 0 174 111"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M39.5288 0.695312L0.681641 48.1751V110.043L39.5288 61.1242V0.695312Z"
          fill={data?.light_colour}
        />
        <g>
          <rect
            x="39.2363"
            y="0.695312"
            width="133.807"
            height="60.4289"
            fill={data?.dark_colour}
          />
          <text
            x="75.2363"
            y="40"
            font-family="'Open Sans', sans-serif"
            font-size="28"
            fill="white"
          >
            {data?.year}
          </text>
        </g>
      </svg>
      <div
        style={{
          ...style.innerContainer,
          visibility: index % 2 === 0 ? 'visible' : 'hidden',
        }}
      >
        <svg
          width="39"
          height="166"
          viewBox="0 0 39 166"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="17.9688"
            y="0.132812"
            width="4.16811"
            height="156.304"
            fill="#62207E"
            fillOpacity="0.4"
          />
          <circle
            cx="19.5314"
            cy="146.539"
            r="18.2775"
            stroke="#BEA4C9"
            strokeWidth="2"
          />
          <circle cx="20.0532" cy="146.016" r="12.5043" fill="#BEA4C9" />
        </svg>
      </div>
      <p
        style={
          index % 2 !== 0
            ? {
                top: 0,
                marginTop: '-56px',
                ...style.para,
                marginLeft: max - 1 === index ? '-46px' : '-26px',
              }
            : {
                bottom: 30,
                ...style.para,
                marginLeft: max - 1 === index ? '-46px' : '-26px',
              }
        }
      >
        {data?.text}
      </p>
    </div>
  );
}
